// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"loadingSpinner__ewCEr"};